module.exports = __webpack_public_path__ + "12105f15.png";